import { useState, useLayoutEffect, useCallback } from 'react';

export function useLayoutHeightFromRef(ref: React.RefObject<HTMLElement | null>) {
  const [height, setHeight] = useState<number>(0);

  const handleResize = useCallback(() => {
    if (ref.current) {
      const newHeight = ref.current.getBoundingClientRect().height;
      setHeight(newHeight);
    }
  }, [ref.current]);

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });
    if (ref.current) {
      // Initial height measurement
      handleResize();

      // Set up ResizeObserver
      resizeObserver.observe(ref.current);
    }

    // Clean up the observer
    return () => {
      resizeObserver.disconnect();
    };
  }, [handleResize]);

  return { height };
}
